export default "__VITE_ASSET__aXgbaGF$__"